import { Injectable, signal } from '@angular/core';
import { Patient } from '@interfaces/patient/patient';

@Injectable({
  providedIn: 'root',
})
export class PatientService {
  patients = signal<Patient[]>([]);

  setPatients(patients: Patient[]) {
    this.patients.set(patients);
  }
}
